import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { environment } from '@environments/environment';
import { CandidateEvaluationFeedback } from '@app/model/candidateEvaluationFeedback';
import { CandidateEvaluationFeedbackSerializer } from '../model/serializer/candidateEvaluationFeedback-serializer';

@Injectable({
  providedIn: 'root'
})
export class CandidateFeedbackEvaluationService extends ApiService<CandidateEvaluationFeedback>{

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'interview/candidate-evaluation-feedback',
      new CandidateEvaluationFeedbackSerializer());
   }
}
